import React from 'react';
import { IconShieldCheckFilled } from '@planne-software/uni/icons';

import { SecurePurchaseLabel, SecurePurchaseRoot } from './styles';

const iconSize = {
  md: 20,
  lg: 24,
};

type SecurePurchaseNoteProps = {
  /** The copy is a caller decision: nothing in `common/` knows the checkout's message keys. */
  label: string;
  className?: string;
  /** The design uses text-lg on the additional info step and text-md on payment. */
  size?: keyof typeof iconSize;
};

export const SecurePurchaseNote = (props: SecurePurchaseNoteProps) => {
  const { label, className, size = 'md' } = props;

  return (
    <SecurePurchaseRoot data-testid='secure-purchase-note' data-size={size} className={className}>
      <IconShieldCheckFilled size={iconSize[size]} aria-hidden />
      <SecurePurchaseLabel>{label}</SecurePurchaseLabel>
    </SecurePurchaseRoot>
  );
};

export default SecurePurchaseNote;
